export const parcoursFormaliteBasePath = 'newformality';
export const parcoursFormalitePrescriberStepPath = 'prescripteur';
export const parcoursFormaliteContactStepPath = 'contact';
export const parcoursFormaliteFormaliteStepPath = 'formalite';
export const parcoursFormaliteClientsStepPath = 'clients';
export const parcoursFormalitePremiumDocsStepPath = 'premimumdocs';
export const parcoursFormaliteFormStepPath = 'form';
export const parcoursFormaliteDocsStepPath = 'docs';
export const parcoursFormaliteRecapStepPath = 'recap';
export const parcoursFormaliteNextFormStepPath = 'next';

export type ParcoursFormaliteSupportedView =
    | 'stepPrescriber'
    | 'stepContact'
    | 'stepFormalite'
    | 'stepClient'
    | 'stepPremiumDoc'
    | 'stepForm'
    | 'stepDocs'
    | 'stepRecap'
    | 'stepNextForm';
